import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./quotaModificationSlice";
import MultilineChart from "./MultilineChart";

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 800,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 1,
   borderRadius: 1
};

export default function GraphModal() {
   const dispatch = useDispatch();
   const {graphModalOpen} = useSelector((store) => store.quotaModification);
   
   function handleClose() {
      dispatch(setState("graphModalOpen", false));
      dispatch(setState("popupGraphData", null));
   }

   return (
      <Box>
         <Modal
            open={graphModalOpen}
            onClose={handleClose}
         >
            <Box sx={style}>
               <MultilineChart/>
            </Box>
         </Modal>
      </Box>
   );
}
